/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upgradesuccessdescription2Inputs */

const en_upgradesuccessdescription2 = /** @type {(inputs: Upgradesuccessdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your plan has been upgraded to ${i?.tier}. All new features are now available.`)
};

const de_upgradesuccessdescription2 = /** @type {(inputs: Upgradesuccessdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Plan ist jetzt ${i?.tier}. Alle neuen Funktionen sind jetzt verfügbar.`)
};

/**
* | output |
* | --- |
* | "Your plan has been upgraded to {tier}. All new features are now available." |
*
* @param {Upgradesuccessdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradesuccessdescription2 = /** @type {((inputs: Upgradesuccessdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradesuccessdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradesuccessdescription2(inputs)
	return de_upgradesuccessdescription2(inputs)
});
export { upgradesuccessdescription2 as "upgradeSuccessDescription" }